import { createContext, useContext, useEffect } from 'react';

type SetAppChromeHidden = (hidden: boolean) => void;

// No-op outside SidebarLayout, so pages rendered elsewhere can call the hook safely.
export const AppChromeContext = createContext<SetAppChromeHidden>(() => undefined);

// Hides SidebarLayout's nav rail and header row while `hidden` is true and the caller is mounted.
export function useHideAppChrome(hidden: boolean): void {
    const setHidden = useContext(AppChromeContext);
    useEffect(() => {
        if (!hidden) return undefined;
        setHidden(true);
        return () => setHidden(false);
    }, [hidden, setHidden]);
}
